'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
require('../../Typography/src/Heading.js');
var Link = require('../../Typography/src/Link.js');
require('../../Typography/src/ListItem.js');
require('../../Typography/src/OrderedList.js');
require('../../Typography/src/Text.js');
require('../../Typography/src/UnorderedList.js');
var Breadcrumb_module = require('../styles/Breadcrumb.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Breadcrumb Item component.
 *
 * @component
 * @example
 * ```jsx
 * <Breadcrumb.Item>Home</Breadcrumb.Item>
 * ```
 */
const Item = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Breadcrumb_module.default);
    return (React__namespace.createElement(Link.Link, { ref: ref, className: cx(className, 'item'), ...restProps, color: "dark" }, children));
});
Item.defaultProps = {};
Item.displayName = 'Item';

exports.Item = Item;
//# sourceMappingURL=BreadcrumbItem.js.map
